import Boxes from './Boxes'

export default Boxes